<div class="noprint">
    <div class="header topbar clearfix noprint" [class.opacity]="!isScrolledDown">
        <div class="transparent-header" [ngStyle]="{'background-color': currentHeaderColor}"></div>
        <div class="header-overlay">
            <div class="main-logo-wrapper logo-area">
                <a class="morpheus-logo-link" href="">
                    <div class="threeD">
                        Say What Live Captions
                    </div>
                </a>
            </div>

            <ul class="header-menu-right topbar-menu fadeInDown d-flex align-items-center"
                [ngClass]="{'topbar-menu-visible': app.topbarMenuActive}">
                <li *ngIf="!isLoggedIn">
                    <button type="button" (click)="app.onTopbarLoginItemClick($event)"
                        class="login-register-btn noprint">
                        <div>
                            <!-- <svg-icon src="assets/images/svg/phlo-sailors.svg" [svgStyle]="{'width.px':35,'height.px':35,'fill':'rgb(255,255,255)'}"></svg-icon> -->
                            <span>Login / Register</span>
                            <span class="mobile">Login</span>
                        </div>
                    </button>
                </li>
                <li #profile class="profile-item" [ngClass]="{'active-topmenuitem':app.activeTopbarItem === profile}"
                    *ngIf="isLoggedIn">
                    <a href="#" (click)="app.onTopbarItemClick($event,profile)">
                        <div class="profile-image">
                            <img *ngIf="currentAvatar" [src]="currentAvatar">
                            <i *ngIf="!currentAvatar" class="pi pi-user" style="font-size: 3em"></i>
                        </div>
                        <span class="profile-text">Profile</span>
                    </a>

                    <ul class="fadeInDown">
                        <li role="menuitem">
                            <a href="#" (click)="app.onTopbarLogoutItemClick($event)">
                                <i class="pi pi-sign-out"></i>
                                <span>Logout</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</div>

<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>